import React from "react"
import { Common } from "lib/types"
import { ReactComponent as DashboardIcon } from "images/icons/chart-line.svg"

import { Home } from "views/Home"
import { Dashboards } from "views/Dashboards/Dashboards"
import { DashboardsSales } from "views/Dashboards/DashboardsSales"
import InsightsDashboard from "views/Dashboards/InsightsDashboard"
import { PermissionGroups } from "../constants"
import OperationsDashboard from "../../views/Dashboards/OperationsDashboard"

export const dashboardRoutes: Common.Views = [
  {
    element: <Home />,
    path: "/",
    title: "Home",
    icon: DashboardIcon,
    sortOrder: 1
  },
  {
    element: <Dashboards />,
    path: "/dashboard",
    title: "Dashboard",
    icon: DashboardIcon,
    sortOrder: 1,
    children: [
      {
        element: <Home />,
        path: "/dashboard/home",
        title: "Home",
        parentPath: "/dashboard",
        section: "Dashboards"
      },
      {
        element: <DashboardsSales />,
        path: "/dashboard/sales",
        title: "Sales",
        parentPath: "/dashboard",
        requiredGroups: PermissionGroups.salesDashboards.read
      },
      {
        element: <InsightsDashboard />,
        path: "/dashboard/insights",
        title: "Insights",
        parentPath: "/dashboard",
        configKey: "insightsEnabled",
        requiredGroups: PermissionGroups.insightsDashboards.read
      },
      {
        element: <OperationsDashboard />,
        path: "/dashboard/operations",
        title: "Operations",
        parentPath: "/dashboard",
        configKey: "operationsEnabled",
        requiredGroups: PermissionGroups.operationsDashboards.read
      }
    ]
  }
]
